import {observer} from "mobx-react";
import * as React from "react";
import FileInputDropZone from "./FileInputDropZone";
import {isMobile} from "react-device-detect";
import FormUtils from "../../scenes/Forms/FormUtils";
import FileInputUploadingFile from "./FileInputUploadingFile";
import FileInputUploadedSuccessfully from "./FileInputUploadedSuccessfully";
import FileInputUploadFailure from "./FileInputUploadFailure";
import {FileInputRenderingStatus, FileStatus} from "./FileStatus";

interface ILocalState {
    fileStatus: FileInputRenderingStatus
}

interface IProps {
    store: any;
    propertyName: string;
    cb: (params: any) => void;
    updateNextStep: (nextIndex: number, val: boolean)=> void;
    stepIndex: number;
    formPageName: string;
    fileStoreValue: string;
}

@observer
export default class FormFileInputContainer extends React.Component<IProps> {
    public state: ILocalState = {
        fileStatus: FileInputRenderingStatus.initial
    };

    public componentWillReceiveProps(nextProps: any) {
        if(this.props.fileStoreValue !== nextProps.fileStoreValue){
            const newState = this.state;
            if(nextProps.fileStoreValue === "" || nextProps.fileStoreValue === FileInputRenderingStatus.initial) {
                newState.fileStatus = FileInputRenderingStatus.initial;
            }else if(nextProps.fileStoreValue === FileStatus.sending) {
                newState.fileStatus = FileInputRenderingStatus.loading;
            } else if(nextProps.fileStoreValue === FileStatus.failure) {
                newState.fileStatus = FileInputRenderingStatus.failure;
            }else {
                newState.fileStatus = FileInputRenderingStatus.success;
            }
        }
    }

    public render() {
        return (
            <>
                {this.renderFileInputByStatus()}
            </>
        );
    };

    private renderFileInputByStatus = () => {
        switch (this.state.fileStatus) {
            case FileInputRenderingStatus.initial: return this.renderFileDropzone();
            case FileInputRenderingStatus.loading: return this.renderFileUploading();
            case FileInputRenderingStatus.success: return this.renderFileUploadCompletedSuccessfully();
            case FileInputRenderingStatus.failure: return this.renderFileUploadCompletedWithError();
            default: return this.renderFileDropzone();
        }
    };

    private renderFileDropzone = () => {
        const {store, cb, propertyName} = this.props;
        return (
            <FileInputDropZone
            onFileUpload={this.handleFile}
            selectionText = {this.getFileSectionText()}
            acceptedFiles={this.getAcceptedFilesToUpload()}
            store={store}
            cb={cb}
            propertyName={propertyName}/>
            )
    };

    private renderFileUploading = () => {
        const {propertyName} = this.props;
        return <FileInputUploadingFile propertyName={propertyName}/>;
    };

    private renderFileUploadCompletedSuccessfully = () => {
        const {updateNextStep, stepIndex, formPageName, store, propertyName} = this.props;
        updateNextStep(stepIndex - 1, true);
        return <FileInputUploadedSuccessfully
            propertyName={propertyName}
            store={store}
            formPageName={formPageName}
            onFileRemoved={this.removeFile} />
    };

    private renderFileUploadCompletedWithError  = () => {
        const {propertyName, updateNextStep, stepIndex} = this.props;
        updateNextStep(stepIndex - 1, true);
        return <FileInputUploadFailure propertyName={propertyName} acceptedFiles={this.getAcceptedFilesToUpload()} onFileUpload={this.handleFile}/>
    };

    private getFileSectionText = () => {
        return !isMobile? <div className="text-container">Drag and drop or<br/> <span className="browse"> browse</span> files</div> : <div>Tap to upload file</div>
    };

    private getAcceptedFilesToUpload = () => {
        const {propertyName, store} = this.props;
        if (store && store.getAcceptedFilesToUpload) {
            return store.getAcceptedFilesToUpload()
        }
        return propertyName.includes('Pdf')? "application/pdf": "image/jpeg, image/png";
    };

    private handleFile = (files: any) => {
        const {propertyName} = this.props;
        FormUtils.fileUploadHandler( files, propertyName);
    };

    private removeFile = () => {
        const {store,formPageName, propertyName, updateNextStep, stepIndex} = this.props;
        store.formInput[formPageName][propertyName] = '';
        if(propertyName === "upgradePdfFile") {
            store.updateFinishForm(false);
        }
        updateNextStep(stepIndex - 1, false);

    };

}



// WEBPACK FOOTER //
// ./src/components/FormFileInput/FormFileInputContainer.tsx